import React from "react";

export default function RestaurantCard({
  name,
  address,
  status = "active",
  trainingCompletion = 78,
  trainingTrend = 2,
  overdueEmployees = 4,
  lastMenuUpdate = "3 days ago",
  employeesInTraining = 12,
  onManageRestaurant,
  variant = "default", // "default" or "director"
}) {
  if (variant === "director") {
    return (
      <div
        // onClick={onManageRestaurant}
        className="bg-white rounded-xl border border-gray-100 shadow-sm hover:shadow-md transition-all p-6 cursor-pointer group flex flex-col h-full"
      >
        <div className="flex justify-between items-start mb-4">
          <div className="flex-1">
            <h3 className="text-lg text-start font-bold text-[#881337] leading-tight group-hover:text-[#a11641] transition-colors">
              {name}
            </h3>
            <p className="text-[11px] text-start font-medium text-gray-400 mt-1 leading-relaxed max-w-[180px]">
              {address}
            </p>
          </div>
          <span className="px-2.5 py-1 rounded-full bg-[#FEF9C3] text-[#A16207] text-[10px] font-bold shadow-sm">
            {status.charAt(0).toUpperCase() + status.slice(1)}
          </span>
        </div>

        <div className="mt-auto grid grid-cols-2 gap-y-6 gap-x-4">
          <div className="space-y-1">
            <p className="text-[12px]  text-gray-400 leading-none">
              Training Completion
            </p>
            <span className="text-lg font-semibold text-gray-800 tracking-tighter block">
              {trainingCompletion}%
            </span>
          </div>

          <div className="space-y-1 pl-2">
            <p className="text-[12px]  text-gray-400 leading-none text-center">
              Overdue Employees
            </p>
            <span className={`text-xl font-semibold tracking-tighter block text-center ${overdueEmployees > 0 ? "text-[#D32F2F]" : "text-gray-800"}`}>
              {overdueEmployees}
            </span>
          </div>

          <div className="space-y-1">
            <p className="text-[12px]  text-gray-400 leading-none">
              Last Menu Update
            </p>
            <span className="text-l font-semibold text-[#475569] tracking-tight block">
              {lastMenuUpdate}
            </span>
          </div>

          <div className="space-y-1 pl-2">
            <p className="text-[12px]  text-gray-400 leading-none text-center">
              Employees in Training
            </p>
            <span className="text-lg font-semibold text-[#475569] tracking-tight block text-center">
              {employeesInTraining}
            </span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      // onClick={onManageRestaurant}
      className="bg-white rounded-xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow p-6 cursor-pointer w-full"
    >
      <div className="flex flex-col mb-6">
        <div className="flex items-center gap-3 mb-1">
          <h3 className="text-xl font-bold text-[#9F1239]">{name}</h3>
          {status === "active" ? (
            <span className="px-2 py-0.5 rounded-full bg-green-100 text-green-700 text-xs font-medium">
              Active
            </span>
          ) : (
            <span className="px-2 py-0.5 rounded-full bg-gray-100 text-gray-500 text-xs font-medium">
              Inactive
            </span>
          )}
        </div>
        <p className="text-sm text-left text-gray-400">{address}</p>
      </div>

      <div className="border-t border-gray-50 my-4"></div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
        <div className="flex flex-col items-center">
          <p className="text-[11px] font-medium text-slate-500 mb-1 uppercase tracking-wider">
            Training Completion
          </p>
          <div className="flex items-center gap-2">
            <span className="text-3xl font-extrabold text-slate-800 leading-none">
              {trainingCompletion}%
            </span>
          </div>
        </div>

        <div className="flex flex-col items-center">
          <p className="text-xs text-gray-500 mb-1">Overdue Employees</p>
          <span className="text-2xl font-bold text-red-600 leading-none">
            {overdueEmployees}
          </span>
        </div>

        <div className="flex flex-col items-center">
          <p className="text-xs text-gray-500 mb-1">Last Menu Update</p>
          <span className="text-xl font-bold text-gray-900 leading-none">
            {lastMenuUpdate}
          </span>
        </div>

        <div className="flex flex-col items-center">
          <p className="text-xs text-gray-500 mb-1">Employees in Training</p>
          <span className="text-2xl font-bold text-gray-900 leading-none">
            {employeesInTraining}
          </span>
        </div>
      </div>
    </div>
  );
}
